import { render, staticRenderFns } from "./OtherCostsNewForm.vue?vue&type=template&id=2c5c6c7e"
import script from "./OtherCostsNewForm.vue?vue&type=script&lang=js"
export * from "./OtherCostsNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports